import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Col, Container, Row, Form, Button, Alert } from "react-bootstrap";
import UploadIcon from "../assets/images/upload_file_rgb_red.svg";
import api from "../services/httpClient";

const DataImportEditDates = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [details, setDetails] = useState(null);
  const [loading, setLoading] = useState(true);
  const [executionDate, setExecutionDate] = useState("");
  const [rollbackDate, setRollbackDate] = useState("");
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);

  useEffect(() => {
    const fetchDetails = async () => {
      try {
        const response = await api.get(`/HistoryBulk/${id}`);
        const data = response.data;
        setDetails(data);

        // Konwersja dat z formatu "dd-MM-yyyy HH:mm:ss" na "yyyy-MM-ddTHH:mm" (datetime-local)
        if (data.executionDate) {
          setExecutionDate(parseDateToLocal(data.executionDate));
        }
        if (data.rollbackDate) {
          setRollbackDate(parseDateToLocal(data.rollbackDate));
        }
      } catch (err) {
        console.error("Error fetching import details:", err);
        setError("Nie udało się pobrać danych importu.");
      } finally {
        setLoading(false);
      }
    };
    fetchDetails();
  }, [id]);

  const parseDateToLocal = (dateStr) => {
    if (!dateStr) return "";
    // Format z API: "dd-MM-yyyy HH:mm:ss"
    const parts = dateStr.match(/(\d{2})-(\d{2})-(\d{4}) (\d{2}):(\d{2})/);
    if (parts) {
      return `${parts[3]}-${parts[2]}-${parts[1]}T${parts[4]}:${parts[5]}`;
    }
    // Fallback — próba bezpośrednia
    try {
      const d = new Date(dateStr);
      if (!isNaN(d.getTime())) {
        return d.toISOString().slice(0, 16);
      }
    } catch { /* ignore */ }
    return "";
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setSuccess(null);

    try {
      const requestBody = {
        id: Number(id),
        executionDate: executionDate || null,
        rollbackDate: rollbackDate || null,
      };

      const response = await api.patch(`/HistoryBulk`, requestBody);
      const msg = response.data?.data?.message || "Daty importu zostały zaktualizowane.";
      setSuccess(msg);

      // Po 2 sekundach wróć do szczegółów
      setTimeout(() => navigate(`/data-import/${id}`), 2000);
    } catch (err) {
      const msg = err.response?.data?.message || "Wystąpił błąd podczas zapisywania dat.";
      setError(msg);
    }
  };

  if (loading) {
    return (
      <Container fluid className="mt-4">
        <p>Ładowanie...</p>
      </Container>
    );
  }

  if (!details) {
    return (
      <Container fluid className="mt-4">
        <p>Nie znaleziono importu o ID {id}.</p>
        <Button variant="secondary" onClick={() => navigate("/data-import")}>
          Powrót do listy
        </Button>
      </Container>
    );
  }

  // Status 2 = DONE — ukryj pole execution_date (spec sekcja 3.3)
  const isDone = details.status === 2;

  // Minimalna data: dzisiaj
  const minDate = new Date().toISOString().slice(0, 16);

  return (
    <div className="data-import-container">
      <Container fluid>
        <Row className="align-items-center mb-4">
          <Col xs="auto">
            <img src={UploadIcon} alt="Data Import Icon" style={{ width: "30px", height: "30px" }} />
          </Col>
          <Col>
            <h3 style={{ fontSize: "1.5rem", fontWeight: "bold" }}>
              Edycja dat importu #{id}
            </h3>
          </Col>
          <Col xs="auto">
            <Button variant="secondary" onClick={() => navigate(`/data-import/${id}`)}>
              Powrót do szczegółów
            </Button>
          </Col>
        </Row>

        {error && <Alert variant="danger">{error}</Alert>}
        {success && <Alert variant="success">{success}</Alert>}

        <Row>
          <Col md={6}>
            <Form onSubmit={handleSubmit}>
              {!isDone && (
                <Form.Group className="mb-3" controlId="executionDate">
                  <Form.Label>Data wykonania</Form.Label>
                  <Form.Control
                    type="datetime-local"
                    value={executionDate}
                    min={minDate}
                    onChange={(e) => setExecutionDate(e.target.value)}
                  />
                  <Form.Text className="text-muted">
                    Dozwolone godziny: 00:00, 06:00–23:00. Minimalna data: dzisiaj.
                  </Form.Text>
                </Form.Group>
              )}

              <Form.Group className="mb-3" controlId="rollbackDate">
                <Form.Label>Data wycofania</Form.Label>
                <Form.Control
                  type="datetime-local"
                  value={rollbackDate}
                  min={minDate}
                  onChange={(e) => setRollbackDate(e.target.value)}
                />
                <Form.Text className="text-muted">
                  Data wycofania musi być w przyszłości{!isDone ? " i późniejsza niż data wykonania" : ""}.
                </Form.Text>
              </Form.Group>

              <div className="d-flex gap-2">
                <Button variant="primary" type="submit">
                  Zapisz daty
                </Button>
                <Button variant="outline-secondary" onClick={() => navigate(`/data-import/${id}`)}>
                  Anuluj
                </Button>
              </div>
            </Form>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default DataImportEditDates;
